import React from 'react'

import Footer from './Footer'
import Modus from './Modus'

const Left = () => {

  return (
    <div className='left'>  
      <div className='left__top'>

      </div>
      <div className='left__bottom'>
        <Modus />
        <Footer />
      </div>
    </div>
  )
}

export default Left